import React from 'react';
import Grid from '@mui/material/Grid2';
import moment from 'moment';
import {
    Box,
} from '@mui/material';

const MetaSection = (props) => {

    const formatDate = (date) => {
        let formattedDate = 'none';
        try {
            formattedDate = moment(date); //format('MM-DD-YYYY');
            if (formattedDate.isValid()) {
                return formattedDate.format('MM-DD-YYYY');
            }
            return ' - '
        } catch (e) {
            formattedDate = ' - '
        }
        return formattedDate;
    }


    return (
        <Box>
            {/*<h2 className="sectionHeading">Metadata</h2>*/}
            <div style={{marginTop: '20px'}} className="preview-header-section">

                <Grid container spacing={0.45}>

                    <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
                        <Grid container>
                            <Grid item size={1.5} className="metadata-label">
                                Policy Number:
                            </Grid>
                            <Grid item  size={10.5} className="metadata-item" style={{textTransform: 'none'}}>
                                {props?.policyShortName}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
                        <Grid container>
                            <Grid item size={1.5} className="metadata-label">
                                Policy Name:
                            </Grid>
                            <Grid item  size={10.5} className="metadata-item" style={{textTransform: 'none'}}>
                                {props?.policyData?.policy?.title}
                            </Grid>
                        </Grid>
                    </Grid>

                    {props?.policyData?.policy?.policy_type && (<Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                        <Grid container>
                            <Grid item size={3} className="metadata-label">
                                Policy Type:
                            </Grid>
                            <Grid item  size={8} className="metadata-item">
                                {props?.policyData?.policy?.policy_type}
                            </Grid>
                        </Grid>
                    </Grid>)}

                    {props?.policyData?.policy?.policy_subtype && (<Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                        <Grid container>
                            <Grid item size={3} className="metadata-label">
                                Policy Subtype:
                            </Grid>
                            <Grid item  size={8} className="metadata-item">
                                {props?.policyData?.policy?.policy_subtype}
                            </Grid>
                        </Grid>
                    </Grid>)}

                    {props?.policyData?.policy?.effectivedate && (<Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                        <Grid container>
                            <Grid item size={3} className="metadata-label">
                                Effective Date:
                            </Grid>
                            <Grid item  size={8} className="metadata-item">
                                {props?.policyData?.policy?.effectivedate ? formatDate(props?.policyData?.policy?.effectivedate) : 'N/A'}
                            </Grid>
                        </Grid>
                    </Grid>)}

                    {props?.policyData?.policy?.inactivedate && (<Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                        <Grid container>
                            <Grid item size={3} className="metadata-label">
                                End Date:
                            </Grid>
                            <Grid item  size={8} className="metadata-item">
                                {props?.policyData?.policy?.inactivedate ? formatDate(props?.policyData?.policy?.inactivedate) : 'N/A'}
                            </Grid>
                        </Grid>
                    </Grid>)}

                    {props?.policyData?.policy?.reviewdate && (<Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                        <Grid container>
                            <Grid item size={3} className="metadata-label">
                                Review Date:
                            </Grid>
                            <Grid item  size={8} className="metadata-item">
                                {props?.policyData?.policy?.reviewdate ? formatDate(props?.policyData?.policy?.reviewdate) : 'N/A'}
                            </Grid>
                        </Grid>
                    </Grid>)}

                    {props?.policyData?.policy?.lastreviewdate && (<Grid item size={{ xs: 12, sm: 6, md: 6 }}>
                        <Grid container>
                            <Grid item size={3} className="metadata-label">
                                 Last Review Date:
                            </Grid>
                            <Grid item  size={8} className="metadata-item">
                                {props?.policyData?.policy?.lastreviewdate ? formatDate(props?.policyData?.policy?.lastreviewdate) : 'N/A'}
                            </Grid>
                        </Grid>
                    </Grid>)}

                </Grid>
            
            </div>
        </Box>
    )

}

export default MetaSection;